import { Component, Input} from '@angular/core';
import { IdxAdjacentItems } from '../_interfaces/icontrols-common/imenubar.interface';
import { BaseComponent } from '../_common/dx-base-component';

@Component({
    selector: 'dx-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    standalone: false
})
export class ToolBarComponent extends BaseComponent {
    @Input() controls!: IdxAdjacentItems[];
    override ngOnInit() {
        super.ngOnInit();
        this.componentName = 'ToolBarComponent';
    }

}
